import React, {useState} from 'react';
import styles from './registration-modal-content.module.scss';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  INVESTOR_REGISTRATION_ERROR,
  INVESTOR_REGISTRATION_SUCCESS,
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {useValidation} from "../../../../../../hooks/use-validation";
import {CurrencyInput, DateInput, DropDown, TextInput} from "../../../../../../components/form/form";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import {getCurrency} from "../../../../../../helpr/listingFormData";
import {required} from "../../../../../../helpr/generic-validation-rules";
import Registration from "../../../../../../models/registration";

const RegistrationModalContent = ({context, onClose}) => {
  //Investor Registration result variables
  const SUCCESS_TITLE = "INVESTOR REGISTRATION APPLICATION SENT";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ page, setPage ] = useState(0);

  //Service call states
  const { setRegistrationList } = context;
  const [ loading, setLoading] = useState(false);
  const secondaryMarketService = new SecondaryMarketService();

  //Validator
  const registrationState = useValidation(
    registrationModalValidator,
    registrationModalObj({
      firstName: '',
      lastName: '',
      emailAddress: '',
      securityId: '',
      faceAmount: '',
      settlementDate: ''
    }),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, ge } = registrationState;

  const send = async () => {
    const { formState, isFormValid } = validate();
    console.log(formState);
    if(!isFormValid){
      return
    }
    setLoading(true);
    try {
      const createdRegistration = await secondaryMarketService.createRegistration(formState);
      setRegistrationList(prev => {
        const newList = prev.concat(new Registration(createdRegistration));
        return newList;
      });
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }
  const renderRegistrationResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={INVESTOR_REGISTRATION_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={INVESTOR_REGISTRATION_ERROR} onClose={onClose}/>
      default:
    }
  }

  return page === 0 ? (
    <div className={styles['registration-modal-content']}>
      <Row>
        <Col lg={{offset: 1, span: 10}}>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('lastName')} placeholder={""}>
                Last Name:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('firstName')} placeholder={""}>
                First Name:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('emailAddress')} placeholder={""}>
                Email Address:*
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('securityId')} placeholder={""}>
                Security ID/ISIN No.:
              </TextInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <CurrencyInput inputProps={getTextFieldProps('faceAmount')} placeholder={""}>
                Face Amount:*
              </CurrencyInput>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <DateInput inputProps={getTextFieldProps('settlementDate')}>
                Settlement Date:*
              </DateInput>
            </Col>
          </Row>
          <Row className={styles['button-row']}>
            <Col xs={6} lg={6}>
              <div className={styles['cancel-button']}>
                <Button variant="secondary" onClick={() => onClose()}>
                  CANCEL
                </Button>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['send-button']}>
                <Button disabled={loading} onClick={() => send()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'SEND'}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : renderRegistrationResult()
}

const registrationModalObj = obj => {
  return {
    fields: {
      firstName: {
        value: obj.firstName,
        style: {}
      },
      lastName: {
        value: obj.lastName,
        style: {}
      },
      emailAddress: {
        value: obj.emailAddress,
        style: {}
      },
      securityId: {
        value: obj.securityId,
        style: {}
      },
      faceAmount: {
        value: obj.faceAmount,
        style: {}
      },
      settlementDate: {
        value: obj.settlementDate,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const registrationModalValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    firstName: [required],
    lastName: [required],
    emailAddress: [required],
    securityId: [required],
    faceAmount: [required],
    settlementDate: [required]
  },
  dynamicFields: {}
}

export default RegistrationModalContent;
